import { createBrowserRouter } from 'react-router';

import { AppSplash } from './app-splash';
import { RootLayout } from './root-layout';
import { privateRoutes } from './routes/private';
import { publicRoutes } from './routes/public';

export const browserRouter = createBrowserRouter([
  {
    Component: RootLayout,
    HydrateFallback: AppSplash,
    children: [privateRoutes, publicRoutes],
  },
]);
